import { toast } from "sonner";
import { Phone, MessageSquare, ExternalLink, Copy, Pin } from "lucide-react";

const copy = async (n) => {
  try { await navigator.clipboard.writeText(n); }
  catch {
    const t = Object.assign(document.createElement("textarea"), { value: n });
    document.body.appendChild(t); t.select(); document.execCommand("copy"); t.remove();
  }
  toast.success(`Copied ${n}`);
};

const NumberLink = ({ kind, number, color, id }) => (
  <span className="inline-flex items-center gap-1">
    <a href={`${kind === "Call" ? "tel" : "sms"}:${number}`} className="hover:underline" style={{ color }}>{kind} {number}</a>
    <button onClick={() => copy(number)} className="p-1 rounded-full text-mm-muted hover:text-mm-primary hover:bg-mm-soft" aria-label={`Copy ${number}`} data-testid={`hotline-copy-${kind.toLowerCase()}-${id}`}><Copy size={12} /></button>
  </span>
);

export const Hotline = ({ h, pinned, onPin }) => {
  const id = h.name.toLowerCase().replace(/[^a-z0-9]+/g, "-");
  return (
    <div className={`mm-card p-4 flex items-center gap-4 ${pinned ? "ring-2 ring-mm-primary" : ""}`} data-testid={pinned ? "hotline-pinned" : `hotline-${h.number}`}>
      <div className="w-1.5 self-stretch rounded-full" style={{ background: h.color }} />
      <div className="flex-1 min-w-0">
        {pinned && <div className="text-[11px] font-bold uppercase tracking-wide text-mm-primary" data-testid="hotline-your-line">Your line</div>}
        <div className="font-semibold">{h.name}</div>
        <div className="text-sm font-semibold mt-0.5 flex flex-wrap gap-x-3" data-testid={`hotline-numbers-${pinned ? "pinned" : h.number}`}>
          {h.canCall && <NumberLink kind="Call" number={h.number} color={h.color} id={id} />}
          {h.canText && <NumberLink kind="Text" number={h.textNumber || h.number} color={h.color} id={id} />}
        </div>
        <div className="text-xs text-mm-muted">{h.description}</div>
      </div>
      <div className="flex flex-wrap justify-end gap-2 shrink-0 max-w-[120px] sm:max-w-none">
        {h.canCall && <a href={`tel:${h.number}`} className="mm-btn !p-2.5" style={{ background: h.color }} aria-label="Call"><Phone size={16} /></a>}
        {h.canText && <a href={`sms:${h.textNumber || h.number}`} className="mm-btn-ghost !p-2.5" aria-label="Text"><MessageSquare size={16} /></a>}
        {h.chatUrl && <a href={h.chatUrl} target="_blank" rel="noreferrer" className="mm-btn-ghost !p-2.5" aria-label="Chat"><ExternalLink size={16} /></a>}
        <button onClick={() => onPin(pinned ? null : h)} className={`mm-btn-ghost !p-2.5 ${pinned ? "!text-mm-primary" : ""}`} aria-label={pinned ? "Unpin this line" : "Pin as your line"} aria-pressed={pinned} data-testid={`hotline-pin-${id}`}>
          <Pin size={16} className={pinned ? "fill-current" : ""} />
        </button>
      </div>
    </div>
  );
};
